<template>
  <div
    class="flex size-full animate-pulse cursor-wait select-none flex-col rounded-lg bg-gray-100 text-transparent opacity-30 shadow-md transition-all"
  >
    <div class="block size-full min-h-[252px] text-clip rounded-t-lg bg-gray-200" />
    <div class="flex flex-col gap-3 p-4">
      <div class="flex gap-x-4">
        <div class="aspect-video size-16 rounded-xl bg-gray-300" />
        <div class="flex flex-col justify-between">
          <p class="rounded-lg bg-gray-300 text-2xl text-transparent">Celebrity Sports: WK</p>
          <p class="items-center rounded-lg bg-gray-300 text-xl">Some nice Shows</p>
        </div>
        <div class="ml-auto flex flex-col justify-between" />
      </div>
    </div>
  </div>
</template>
